jQuery( function ( $ ) {

  var $document = $(document);
  var $html = $('html');

  function getIDfromYouTubeURL(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match && match[7].length == 11)? match[7] : false;
  }

  function getIDfromVimeoURL(url){
    var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
    var match = url.match(regExp);
    return (match && match[5]) ? match[5] : false;
  }


  function initClickHandlers() {

    $document.on('click', '[data-video-modal]', function(e) {
      e.preventDefault();

      var $this = $(this);
      var videoURL = $this.attr('data-video-modal') || $this.attr('href');
      var modalhtml = '<button class="modal-close" data-video-modal-close></button>';

      if (videoURL.indexOf('youtube') != -1) {
        modalhtml += '<iframe src="https://www.youtube.com/embed/'+ getIDfromYouTubeURL(videoURL) +'?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

      } else if (videoURL.indexOf('vimeo') != -1) {
        modalhtml += '<iframe src="https://player.vimeo.com/video/'+ getIDfromVimeoURL(videoURL) +'?autoplay=1&title=0&byline=0&portrait=0&color=e42229" frameborder="0" allowfullscreen></iframe>';
      }

      $('.video-modal-content').html(modalhtml);

      $html.addClass('video-modal-open');

    });

    $document.on('click', '[data-video-modal-close]', function(e) {
      $html.removeClass('video-modal-open');

      setTimeout(function() {
        $('.video-modal-content').html('');
      }, 1500);
    });

  };

  initClickHandlers();

} );